import { environment } from 'src/environments/environment';
import { SiteViewConfiguration } from '../enums';


export class RegionNameMap {
  public static getRegionName(regionid: number) {
    switch (environment.viewConfiguration) {
      case SiteViewConfiguration.SERBIA:

        return RegionNameMap.getRegionNameSrb(regionid);


      case SiteViewConfiguration.CROATIA:
        return RegionNameMap.getRegionNameCro(regionid);


      default:
        return RegionNameMap.getRegionNameSrb(regionid);

    }
  }

  private static getRegionNameSrb(regionId: number) {
    switch (regionId) {
      case 1:
      case 63:
      case 132:
      case 177:
      case 268:
      case 288:
      case 391:
      case 434:
        return 'england';
      case 2:
      case 103:
      case 104:
      case 123:
      case 167:
      case 201:
      case 222:
      case 240:
      case 244:
      case 250:
      case 254:
      case 258:
      case 260:
      case 261:
      case 267:
      case 269:
      case 282:
      case 286:
      case 287:
      case 289:
      case 294:
      case 295:
      case 296:
      case 297:
      case 299:
      case 320:
      case 399:
      case 400:
      case 401:
      case 470:
        return 'international';

      case 24:
      case 126:
      case 200:
      case 220:
      case 245:
      case 313:
      case 422:
        return 'spain';

      case 30:
      case 64:
      case 129:
      case 226:
      case 425:
      case 513:
        return 'turkey';

      case 28:
      case 148:
      case 209:
      case 231:
      case 247:
      case 368:
      case 413:
        return 'portugal';

      case 4:
      case 127:
      case 175:
      case 203:
      case 225:
      case 393:
        return 'france';

      case 22:
      case 49:
      case 128:
      case 164:
      case 190:
      case 195:
      case 217:
      case 259:
      case 394:
      case 433:
        return 'germany';

      case 65:
        return 'albania';

      case 79:
      case 491:
        return 'algeria';

      case 93:
        return 'andorra';

      case 109:
        return 'angola';

      case 32:
      case 145:
      case 372:
      case 374:
        return 'argentina';

      case 74:
      case 850:
        return 'armenia';

      case 26:
      case 130:
      case 243:
      case 290:
      case 375:
      case 448:
      case 535:
        return 'australia';

      case 12:
      case 46:
      case 137:
      case 169:
      case 199:
      case 219:
      case 376:
      case 432:
        return 'austria';

      case 75:
        return 'azerbaijan';

      case 86:
      case 814:
        return 'bahrain';

      case 43:
      case 176:
      case 377:
      case 450:
      case 488:
      case 573:
      case 581:
        return 'belarus';

      case 25:
      case 139:
      case 229:
      case 378:
        return 'belgium';
      case 95:
        return 'bolivia';
      case 56:
      case 514:
        return 'bosnia-herzegovina';
      case 10:
      case 144:
      case 236:
      case 249:
      case 379:
      case 559:
      case 900:
        return 'brazil';
      case 40:
      case 154:
      case 234:
      case 380:
        return 'bulgaria';
      case 102:
      case 666:
      case 965:
        return 'cameroon';
      case 99:
      case 174:
      case 239:
      case 436:
        return 'canada';
      case 33:
      case 381:
      case 435:
        return 'chile';
      case 47:
      case 159:
      case 327:
      case 382:
      case 934:
        return 'china';
      case 67:
      case 383:
        return 'colombia';
      case 72:
      case 384:
        return 'costa-rica';
      case 11:
      case 140:
      case 207:
      case 232:
      case 385:
        return 'croatia';
      case 48:
      case 306:
      case 386:
        return 'cyprus';
      case 13:
      case 134:
      case 165:
      case 206:
      case 227:
      case 248:
      case 387:
      case 284:
      case 813:
        return 'czech-republic';
      case 5:
      case 45:
      case 142:
      case 168:
      case 197:
      case 228:
      case 283:
      case 388:
        return 'denmark';
      case 60:
      case 389:
        return 'ecuador';
      case 80:
      case 390:
        return 'egypt';
      case 91:
        return 'el-salvador';
      case 44:
      case 141:
      case 441:
      case 479:
        return 'estonia';
      case 62:
      case 527:
        return 'faroe-islands';
      case 14:
      case 133:
      case 163:
      case 202:
      case 221:
      case 281:
      case 300:
      case 338:
      case 392:
      case 455:
      case 474:
      case 537:
      case 951:
        return 'finland';
      case 66:
      case 480:
        return 'georgia';
      case 115:
        return 'ghana';
      case 121:
        return 'gibraltar';
      case 38:
      case 125:
      case 208:
      case 224:
      case 395:
      case 489:
        return 'greece';
      case 89:
        return 'guatemala';
      case 107:
      case 396:
        return 'honduras';
      case 85:
        return 'hong-kong';
      case 8:
      case 205:
      case 242:
      case 304:
      case 397:
      case 490:
        return 'hungary';
      case 7:
      case 307:
      case 311:
        return 'iceland';
      case 87:
      case 291:
      case 398:
        return 'india';
      case 92:
      case 465:
      case 477:
        return 'indonesia';
      case 77:
      case 309:
      case 373:
      case 402:
      case 485:
        return 'iran';
      case 586:
        return 'iraq';
      case 34:
        return 'ireland';
      case 37:
      case 138:
      case 216:
      case 403:
      case 484:
        return 'israel';
      case 23:
      case 124:
      case 173:
      case 194:
      case 218:
      case 241:
      case 246:
      case 404:
      case 493:
        return 'italy';
      case 101:
        return 'ivory-coast';
      case 110:
        return 'jamaica';
      case 35:
      case 157:
      case 191:
      case 255:
      case 326:
      case 405:
        return 'japan';
      case 83:
        return 'jordan';
      case 68:
      case 473:
      case 475:
        return 'kazakhstan';
      case 117:
        return 'kenya';
      case 84:
      case 406:
        return 'kuwait';
      case 59:
      case 143:
      case 310:
      case 445:
        return 'latvia';
      case 106:
        return 'lebanon';
      case 111:
        return 'liechtenstein';
      case 58:
      case 136:
      case 453:
        return 'lithuania';
      case 61:
        return 'luxembourg';
      case 57:
        return 'macedonia';
      case 41:
        return 'malaysia';
      case 52:
        return 'malta';
      case 9:
      case 156:
      case 193:
      case 407:
        return 'mexico';
      case 69:
        return 'moldova';
      case 97:
        return 'montenegro';
      case 78:
      case 408:
        return 'morocco';
      case 27:
      case 153:
      case 322:
        return 'netherlands';
      case 53:
      case 292:
      case 538:
        return 'new-zealand';
      case 113:
        return 'nigeria';
      case 50:
      case 409:
        return 'northern-ireland';
      case 3:
      case 161:
      case 196:
      case 280:
      case 302:
      case 303:
      case 323:
      case 410:
        return 'norway';
      case 105:
        return 'oman';
      case 315:
      case 515:
        return 'pakistan';
      case 114:
        return 'palestine';
      case 112:
        return 'panama';
      case 70:
      case 411:
        return 'paraguay';
      case 15:
      case 449:
        return 'peru';
      case 119:
      case 158:
      case 437:
        return 'philippines';
      case 31:
      case 147:
      case 172:
      case 213:
      case 233:
      case 252:
      case 412:
        return 'poland';
      case 88:
      case 414:
        return 'qatar';
      case 39:
      case 152:
      case 210:
      case 253:
      case 324:
      case 415:
        return 'romania';
      case 16:
      case 135:
      case 171:
      case 212:
      case 230:
      case 251:
      case 301:
      case 416:
      case 722:
      case 818:
        return 'russia';
      case 98:
        return 'san-marino';
      case 81:
      case 417:
        return 'saudi-arabia';
      case 17:
      case 418:
        return 'scotland';
      case 120:
        return 'senegal';
      case 54:
      case 149:
      case 215:
      case 235:
        return 'serbia';
      case 29:
        return 'singapore';
      case 18:
      case 155:
      case 170:
      case 211:
      case 237:
        return 'slovakia';
      case 19:
      case 150:
      case 214:
      case 419:
        return 'slovenia';
      case 82:
      case 293:
      case 420:
        return 'south-africa';
      case 73:
      case 192:
      case 305:
      case 325:
      case 421:
        return 'south-korea';
      case 6:
      case 55:
      case 131:
      case 162:
      case 198:
      case 223:
      case 279:
      case 298:
      case 423:
      case 801:
        return 'sweden';
      case 20:
      case 151:
      case 166:
      case 204:
      case 285:
      case 321:
      case 424:
        return 'switzerland';
      case 116:
        return 'tanzania';
      case 108:
      case 431:
      case 444:
      case 456:
      case 554:
        return 'thailand';
      case 94:
      case 478:
      case 607:
        return 'tunisia';
      case 42:
      case 146:
      case 426:
      case 443:
      case 472:
      case 481:
      case 516:
      case 899:
        return 'ukraine';
      case 76:
      case 427:
      case 1009:
        return 'united-arab-emirate';
      case 36:
      case 308:
      case 428:
        return 'uruguay';
      case 21:
      case 122:
      case 160:
      case 189:
      case 238:
      case 429:
      case 466:
        return 'usa';
      case 96:
        return 'uzbekistan';
      case 71:
      case 520:
        return 'venezuela';
      case 90:
      case 667:
        return 'vietnam';
      case 51:
      case 430:
        return 'wales';
      case 118:
        return 'zambia';
      case 178:
        return 'atp';
      case 179:
      case 187:
        return 'wta';
      case 180:
        return 'challenger';
      case 181:
        return 'fed-cup';
      case 182:
        return 'davis-cup';
      case 183: // Exhibition
      case 184: // Hopman Cup
      case 185: // ITF Women
      case 186: // ITF Men
        return 'itf';
      case 188:
        return 'iptl';
      case 270:
        return 'formula1';
      case 483:
        return 'sudan';
      case 318:
        return 'uganda';
      case 319:
        return 'rwanda';
      case 256:
      case 257:
      case 454:
        return 'rugby-union-sevens';
      case 487:
        return 'myanmar';
      case 314:
        return 'kosovo';
      case 312:
        return 'syria';
      case 100:
      case 829:
      case 909:
        return 'nicaragua';
      case 316:
        return 'botswana';
      case 588:
        return 'burundi';
      case 604:
        return 'barbados';
      case 697:
        return 'mali';
      case 476:
      case 519:
        return 'bangladesh';
      case 618:
        return 'dominican-republic';
      case 317:
        return 'zimbabwe';
      case 439:
        return 'trinidad-and-tobago';
      case 679:
        return 'cambodia';
      case 614:
        return 'afghanistan';
      case 467:
        return 'republic-of-congo';
      case 536:
        return 'sri-lanka';
      case 721:
        return 'bhutan';
      case 704:
        return 'cuba';
      case 703:
        return 'gambia';
      case 605:
        return 'haiti';
      case 698:
        return 'nepal';
      case 716:
        return 'saint-kitts-and-nevis';
      case 603:
        return 'aruba';
      case 557:
        return 'malawi';
      case 553:
      case 662:
      case 812:
        return 'chinese-taipei';
      case 609:
      case 713:
      case 888:
        return 'tajikistan';
      case 893:
      case 901:
        return 'turkmenistan';
      case 942:
        return 'saint-vincent-and-the-grenadines';
      case 974:
        return 'mongolia';
      case 582:
        return 'mauritania';
      case 699:
        return 'ethiopia';
      // case 696:
      //   return 'burkina_faso';
      //   return 'burkina-faso';



      default:
        return 'international';
    }
  }

  private static getRegionNameCro(regionId: number) {
    switch (regionId) {
      case 1056:
      case 1107:
      case 1473:
      case 1265:
        return 'england';

      case 1064:
      case 1135:
      case 1142:
      case 1425:
      case 1042:
      case 1177:
      // case 1191:
      case 1245:
      case 1284:
      case 1188:
      case 1268:
      case 1287:
      case 1219:
      case 1563:
      case 1293:
      case 1455:
      case 1262:
      case 1263:
      case 1285:
      case 1279:
      case 1311:
      case 1317:
      case 1310:
      case 1319:
        return 'international';

      case 1060:
      case 1460:
      case 1157:
      case 1257:
      case 1382:
      case 1406:
        return 'spain';

      case 1087:
      case 1153:
      case 1337:
      case 1350:
      case 1221:
        return 'turkey';

      case 1071:
      case 1165:
      case 1251:
      case 1224:
      case 1408:
      case 1305:
        return 'portugal';

      case 1063:
      case 1158:
      case 1341:
      case 1241:
      case 1220:
        return 'france';

      case 1084:
      case 1101:
      case 1327:
      case 1501:
      case 1192:
      case 1242:
      case 1216:
      case 1419:
        return 'germany';

      case 1145:
        return 'albania';

      case 1534:
        return 'algeria';

      case 1459:
        return 'andorra';

      case 1582:
        return 'angola';

      case 1458:
      case 1503:
      case 1569:
      case 1604:
        return 'argentina';

      case 1098:
      case 1438:
        return 'armenia';

      case 1086:
      case 1511:
      case 1575:
      case 1275:
      case 1400:
      case 1521:
        return 'australia';

      case 1067:
      case 1089:
      case 1162:
      case 1179:
      case 1236:
      case 1218:
        return 'austria';

      case 1091:
        return 'azerbaijan';

      case 1128:
      case 1507:
        return 'bahrain';

      case 1055:
      case 1320:
      case 1184:
      case 1237:
      case 1233:
      case 1288:
        return 'belarus';

      case 1079:
      case 1368:
      case 1390:
        return 'belgium';
      case 1525:
        return 'bolivia';
      case 1100:
      case 1372:
      case 1451:
      case 1394:
        return 'bosnia-herzegovina';
      case 1054:
      case 1321:
      case 1578:
      case 1228:
      case 1289:
      case 1399:
        return 'brazil';
      case 1082:
      case 1371:
      case 1453:
      case 1457:
      case 1391:
        return 'bulgaria';
      case 1476:
        return 'cameroon';
      case 1132:
      case 1339:
      case 1300:
        return 'canada';
      case 1059:
        return 'chile';
      case 1043:
      case 1322:
      // case 1443: duplo
      case 1508:
      case 1214:
        return 'china';
      case 1081:
        return 'colombia';
      case 1099:
        return 'costa-rica';
      case 1092:
      case 1163:
      case 1437:
      case 1345:
      case 1225:
      case 1409:
        return 'croatia';
      case 1062:
      case 1373:
      case 1478:
        return 'cyprus';
      case 1050:
      case 1159:
      case 1176:
      case 1238:
      case 1189:
      case 1222:
      case 1290:
      case 1316:
        return 'czech-republic';
      case 1047:
      case 1150:
      case 1323:
      case 1178:
      case 1239:
      case 1389:
      case 1315:
        return 'denmark';
      case 1106:
        return 'ecuador';
      case 1076:
      case 1169:
      case 1528:
      case 1591:
        return 'egypt';
      case 1363:
        return 'el-salvador';
      case 1077:
      case 1325:
      case 1398:
      case 1392:
      case 1477:
        return 'estonia';
      case 1108:
        return 'faroe-islands';
      case 1053:
      case 1152:
      case 1326:
      case 1175:
      case 1240:
      case 1383:
      case 1410:
      case 1417:
      case 1314:
      case 1529:
        return 'finland';
      case 1103:
      case 1376:
      case 1571:
        return 'georgia';
      case 1505:
        return 'ghana';
      case 1464:
        return 'gibraltar';
      case 1058:
      case 1156:
      case 1346:
      case 1388:
      case 1291:
        return 'greece';
      case 1124:
        return 'guatemala';
      case 1143:
        return 'honduras';
      case 1137:
      case 1443:
        return 'hong-kong';
      case 1074:
      case 1328:
      case 1243:
      case 1232:
      case 1304:
      case 1292:
        return 'hungary';
      case 1069:
      case 1329:
      case 1244:
        return 'iceland';
      case 1362:
      case 1267:
        return 'india';
      case 1147:
      case 1616:
        return 'indonesia';
      case 1492:
      case 1502:
      case 1395:
        return 'iran';
      case 1461:
      case 1595:
        return 'iraq';
      case 1044:
      case 1374:
      case 1269:
      case 1536:
      case 1447:
      case 1448:
        return 'ireland';
      case 1066:
      case 1367:
      case 1347:
      case 149:
        return 'israel';
      case 1090:
      case 1155:
      case 1196:
      case 1348:
      case 1217:
      case 1415:
      case 1407:
        return 'italy';
      case 1617:
        return 'ivory-coast';
      case 1057:
      case 1330:
      case 1193:
      case 1433:
      case 1294:
        return 'japan';
      case 1068:
      case 1566:
      case 1615:
        return 'jordan';
      case 1065:
      case 1537:
      case 1186:
      case 1434:
        return 'kazakhstan';
      case 1471:
        return 'kenya';
      case 1131:
        return 'kuwait';
      case 1104:
      case 1185:
      case 1246:
        return 'latvia';
      case 1422:
        return 'lebanon';
      case 1462:
        return 'liechtenstein';
      case 1126:
      case 1161:
      case 1342:
      case 1247:
      case 1393:
        return 'lithuania';
      case 1125:
        return 'luxembourg';
      case 1115:
      case 1332:
      case 1248:
      case 1442:
        return 'macedonia';
      case 1088:
      case 1270:
        return 'malaysia';
      case 1136:
        return 'malta';
      case 1072:
      case 1167:
      case 1436:
        return 'mexico';
      case 1139:
        return 'moldova';
      case 1116:
      case 1430:
      case 1479:
      case 1522:
        return 'montenegro';
      case 1102:
        return 'morocco';
      case 1080:
      case 1331:
      case 1385:
      case 1318:
        return 'netherlands';
      case 1141:
      case 1187:
      case 1435:
        return 'new-zealand';
      case 1596:
        return 'nigeria';
      case 1365:
        return 'northern-ireland';
      case 1048:
      case 1149:
      case 1366:
      case 1173:
      case 1249:
      case 1386:
      case 1312:
      case 1509:
        return 'norway';
      case 1445:
        return 'oman';
      case 1423:
      case 1402:
        return 'pakistan';
      case 1469:
        return 'palestine';
      case 1446:
        return 'panama';
      case 1110:
        return 'paraguay';
      case 1111:
        return 'peru';
      case 1463:
      case 1375:
        return 'philippines';
      case 1070:
      case 1164:
      case 1182:
      case 1250:
      case 1226:
      case 1295:
      case 1301:
        return 'poland';
      case 1113:
      case 1565:
      case 1252:
      case 1235:
        return 'qatar';
      case 1045:
      case 1370:
      case 1580:
      case 1253:
      case 1456:
      case 1411:
        return 'romania';
      case 1046:
      case 1160:
      case 1181:
      case 1254:
      case 1190:
      case 1223:
      case 1296:
      case 1500:
        return 'russia';
      case 1123:
        return 'san-marino';
      case 1097:
        return 'saudi-arabia';
      case 1095:
        return 'scotland';
      case 1605:
        return 'senegal';
      case 1094:
      case 1334:
      case 1349:
      case 1227:
      case 1412:
        return 'serbia';
      case 1144:
        return 'singapore';
      case 1061:
      case 1335:
      case 1180:
      case 1255:
      case 1230:
        return 'slovakia';
      case 1096:
      case 1166:
      case 1183:
      case 1256:
      case 1231:
      case 1297:
        return 'slovenia';
      case 1083:
      case 1475:
        return 'south-africa';
      case 1075:
      case 1333:
      case 1194:
      case 1542:
      case 1432:
        return 'south-korea';
      case 1049:
      case 1151:
      case 1336:
      case 1174:
      case 1258:
      case 1387:
      case 1302:
      case 1418:
      case 1472:
        return 'sweden';
      case 1114:
      case 1369:
      case 1343:
      case 1259:
      case 1384:
      case 1313:
        return 'switzerland';
      case 1112:
      case 1524:
        return 'tanzania';
      case 1122:
      case 1377:
      case 1570:
      case 1414:
        return 'thailand';
      case 1078:
      case 1474:
      case 1260:
      case 1234:
        return 'tunisia';
      case 1051:
      case 1338:
      case 1344:
      case 1261:
      case 1229:
      case 1298:
        return 'ukraine';
      case 1361:
      case 1564:
      case 1009:
        return 'united-arab-emirates';
      case 1052:
      case 1168:
      case 1397:
        return 'uruguay';
      case 1073:
      case 1154:
      case 1172:
      case 1191:
      case 1299:
      case 1577:
      case 1498:
        return 'usa';
      case 1085:
        return 'uzbekistan';
      case 1421:
      case 1523:
      case 1545:
        return 'venezuela';
      case 1093:
      case 1431:
      case 1396:
      case 1413:
        return 'vietnam';
      case 1120:
        return 'wales';
      case 1470:
        return 'zambia';
      case 1197:
        return 'atp';
      case 1198:
        return 'wta';
      case 1199:
        return 'challenger';
      case 1200:
        return 'davis-cup';
      case 1202: // ITF Women
      case 1203: // ITF Men
      case 1465: // Juniors
      case 1466: // Wheelchairs:
        return 'itf';
      case 1489:
        return 'formula1';
      case 1133:
        return 'sudan';
      case 1555:
        return 'uganda';
      case 1520:
      case 1444:
        return 'rwanda';
      case 1276:
      case 1277:
        return 'rugby-union-sevens';
      case 1105:
        return 'myanmar';
      case 1148:
      case 1598:
        return 'kosovo';
      case 1140:
      case 1527:
      case 1614:
        return 'syria';
      case 1127:
      case 1170:
      case 1510:
        return 'nicaragua';
      case 1119:
        return 'burundi';
      case 1171:
      case 1631:
        return 'mali';
      case 1553:
        return 'kyrgyzstan';
      case 1513:
      case 1401:
        return 'bangladesh';
      case 1364:
      case 1519:
        return 'dominican-republic';
      case 1121:
        return 'cambodia';
      case 1266:
        return 'afghanistan';
      case 1554:
        return 'republic-of-congo';
      case 1539:
        return 'sri-lanka';
      case 1134:
        return 'bhutan';
      case 1618:
        return 'gambia';
      case 1130:
        return 'haiti';
      case 1608:
        return 'nepal';
      case 1452:
        return 'saint-kitts-and-nevis';
      case 1526:
        return 'malawi';
      case 1129:
      case 1439:
      case 1195:
      case 1552:
        return 'chinese-taipei';
      case 1138:
        return 'tajikistan';
      case 1359:
        return 'turkmenistan';
      case 1499:
        return 'saint-vincent-and-the-grenadines';
      case 1117:
        return 'mongolia';
      case 1109:
        return 'mauritania';
      case 1579:
        return 'ethiopia';



      default:
        return 'international';
    }
  }
}
